import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Button, Spacer, TextCapitalized } from "@qivia/ui";
import { Switch } from "@qivia/ui/src/designSystem/components/Switch";
import { TextAreaDS } from "@qivia/ui/src/designSystem/components/Inputs/TextAreaInput";
import { Page } from "../../components/Page";
import "../../../i18n/i18n";

interface VehicleRestitutionConditionStepProps {
  isCabinCleaned: boolean;
  setIsCabinCleaned: (value: boolean) => void;
  isTrunkCleaned: boolean;
  setIsTrunkCleaned: (value: boolean) => void;
  observations: string;
  setObservations: (value: string) => void;
  onReturn: () => void;
  onValidate: () => void;
}

export const VehicleRestitutionConditionStep = (
  props: VehicleRestitutionConditionStepProps,
) => {
  const { t } = useTranslation();

  return (
    <Page
      title={t("restitution.vehicleCondition.title")}
      returnButton
      returnButtonAction={props.onReturn}
      helpButton
      withoutHeaderSpacer
      bottomButton={
        <Button
          title={t("restitution.button.validate")}
          onClick={props.onValidate}
          height={3.5}
        />
      }
    >
      <StyledForm>
        <Spacer y={1} />
        <StyledRow>
          <TextCapitalized>
            {t("restitution.vehicleCondition.isCabinCleaned")}
          </TextCapitalized>
          <Switch
            checked={props.isCabinCleaned}
            onClick={() => props.setIsCabinCleaned(!props.isCabinCleaned)}
            size="S"
            color="GREEN"
          />
        </StyledRow>
        <Spacer y={1} />
        <StyledRow>
          <TextCapitalized>
            {t("restitution.vehicleCondition.isTrunkCleaned")}
          </TextCapitalized>
          <Switch
            checked={props.isTrunkCleaned}
            onClick={() => props.setIsTrunkCleaned(!props.isTrunkCleaned)}
            size="S"
            color="GREEN"
          />
        </StyledRow>
        <Spacer y={1.5} />
        <StyledFlex>
          <TextCapitalized>
            {t("restitution.vehicleCondition.observations.label")}
          </TextCapitalized>
        </StyledFlex>
        <Spacer y={0.5} />
        <TextAreaDS
          value={props.observations}
          $update={props.setObservations}
          placeholder={
            t("restitution.vehicleCondition.observations.placeholder") || ""
          }
        />
        <Spacer y={1.5} />
        <StyledFlex>
          <TextCapitalized>
            {t("restitution.vehicleCondition.photos.label")}
          </TextCapitalized>
        </StyledFlex>
        {/* TODO: add photo upload later */}
      </StyledForm>
    </Page>
  );
};

const StyledForm = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const StyledRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const StyledFlex = styled.div`
  display: flex;
`;
